import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { GUESTPRO_URL, waLink, WA_DEFAULT_MSG } from "@/lib/site";

const LINKS = [
  { href: "/#rooms", label: "Rooms & Stays" },
  { href: "/#surf-services", label: "Surf & Transfers" },
  { href: "/board-transfer", label: "Board Cargo" },
  { href: "/#hotel-facilities", label: "Facilities" },
  { href: "/#dining", label: "Rooftop & Dining" },
  { href: "/#reviews", label: "Guest Note" },
  { href: "/blog", label: "Blog" },
  { href: "/#faq", label: "FAQ" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="sticky top-0 z-50 bg-sand-50/95 backdrop-blur-md border-b border-sand-200">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Link
            to="/"
            data-testid="nav-brand-link"
            className="text-xl tracking-tight font-display font-semibold text-ocean-900"
          >
            Raffiel Nias
          </Link>
          <span className="text-xs uppercase tracking-widest text-fog font-mono-clean border-l border-sand-200 pl-3 hidden xl:inline">
            Sorake Beach · Lagundri Bay
          </span>
        </div>
        <nav className="hidden lg:flex items-center gap-5 text-[13px] font-medium text-fog whitespace-nowrap">
          {LINKS.map((l) => (
            <Link
              key={l.href}
              to={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={`hover:text-ocean-700 transition-colors ${
                location.pathname === l.href ? "text-ocean-700" : ""
              }`}
            >
              {l.label}
            </Link>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a
            href={waLink(WA_DEFAULT_MSG)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-whatsapp-button"
            className="hidden sm:inline-flex items-center justify-center px-4 py-2.5 rounded-full text-xs font-semibold uppercase tracking-wider text-ocean-700 border border-ocean-700 hover:bg-ocean-700 hover:text-white transition-colors"
          >
            WhatsApp Team
          </a>
          <a
            href={GUESTPRO_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-book-direct-button"
            className="inline-flex items-center justify-center px-5 py-2.5 rounded-full text-xs font-semibold uppercase tracking-wider bg-ocean-700 text-white hover:bg-ocean-800 shadow-sm transition-colors"
          >
            Book Direct
          </a>
          <button
            data-testid="nav-mobile-menu-button"
            className="lg:hidden p-2 text-ocean-900"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {open && (
        <nav
          data-testid="nav-mobile-menu"
          className="lg:hidden border-t border-sand-200 bg-sand-50 px-6 py-4 flex flex-col gap-3 text-sm font-medium text-fog"
        >
          {LINKS.map((l) => (
            <Link
              key={l.href}
              to={l.href}
              onClick={() => setOpen(false)}
              className="hover:text-ocean-700 transition-colors py-1"
            >
              {l.label}
            </Link>
          ))}
          <a
            href={waLink(WA_DEFAULT_MSG)}
            target="_blank"
            rel="noopener noreferrer"
            className="text-ocean-700 font-semibold py-1"
          >
            WhatsApp Team
          </a>
        </nav>
      )}
    </header>
  );
};

export default Navbar;
